import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

export default function YogaNavBar() {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate('/yoga')
        navigate(0)
    }
    return (
      <>
      <nav className="text-gray-600">
      <div className="flex justify-between mx-auto py-4 pl-2 md:pr-4 md:pl-4">
      <div className="flex items-center space-x-5" id="navbar-default">
  <ul className="flex items-center space-x-5">
    <li>
      <Link to="/yoga">Home</Link>
    </li>
    <li>
      <Link to="/yoga/schedule">Schedule</Link>
    </li>
    <li>
      <Link to="/yoga/services">Services</Link>
    </li>
    <li>
      <Link to="/yoga/contact">Contact</Link>
    </li>
  </ul>
</div>
<Link
    to="https://www.instagram.com/sina.in.flux/"
    className="block"
    target="_blank"
    rel="noopener noreferrer"
  >
    <img
      className="w-8 h-8 rounded-full"
      src={require("./images/instagram_logo.png")}
      alt="Instagram Logo"
    />
  </Link>

      </div>
    </nav>
      </>
    );
};
